<template>

  <div>
    <hit_icon v-if="error" :id="'remove'" class="hit-text-danger"/>
    <hit_icon v-if="!error" :id="'ok'" class="hit-text-success"/>
  </div>

</template>

<script>

export default{
  props: {error: Boolean}
}

</script>
